<template>
    <div class="Information">
        <div class="row">
            <div class="col">
                <ActionButton class="DeleteButton"
                              :requires-confirmation="true"
                              confirmation-string="WARNING: You are about to delete this child's entire case file, and enrollment in this program.  This is the equivilant of shredding an entire file.  This will not affect the Client Record, or any other enrollment records."
                              endpoint="Foster/FosterClients/DeleteClientSubProgramMembership"
                              :payload="{ProgramMembershipID: ChildRecordData.Id}"
                              :perform-global-update="true"
                              button-variant="danger"
                              button-string="DELETE CHILD PROGRAM ENROLLMENT RECORD"
                              button-size="md"
                              v-on:success="OnClientSubProgramMembershipDeleted"
                              style="white-space: normal;"/>
            </div>
        </div>
        <!--<div class="row">
            <div class="col padding-top-md pointer" v-on:click="ToggleEditMode()">
                <font-awesome-icon :icon="['fa', 'edit']" />
                <span v-if="EditMode"> Edit Mode: ON</span>
                <span v-else> Edit Mode: OFF</span>
            </div>
        </div>-->
    </div>
</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faEdit } from '@fortawesome/free-solid-svg-icons';
    //library.add(faEdit);
    //import components
    import ActionButton from '../../../Core/ItemEditors/ActionButton.vue';

    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            ToggleEditMode() {
                this.EditMode = !this.EditMode;
            },
            OnClientSubProgramMembershipDeleted() {
                this.$parent.CloseRecord("Clients.ClientProfiles.Remove", "ChildList",this.ChildRecordData.Id);
            }
        },
        components: {
            ActionButton
        },
        mounted() {

        },
        computed: {
            
        }
    }
</script>

<style scoped>
    .DeleteButton {
    display: inline-block;
    font-size:4px;
    }
</style>